import ENV from "config/Env";
import { typedQueryClient, useTypedMutation } from "hooks";
import { HoldingsQueryKeys } from "modules/HoldingsDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

export const useDeleteHoldingMutation = () =>
  useTypedMutation<number, void>({
    mutationFn: async id => {
      await ApiInstance.post("/holdings/delete", { id }, ENV.holdingBaseURL);
    },
    onSuccess: deletedId => {
      const holdings = typedQueryClient.getQueryData(HoldingsQueryKeys.list);
      if (!holdings?.length) return;

      const holdingIdx = holdings.findIndex(({ id }) => id === deletedId);
      if (holdingIdx === -1) return;

      typedQueryClient.setQueryData(HoldingsQueryKeys.list, holdings.toSpliced(holdingIdx, 1));
    }
  });
